import React from 'react';
import {
  FontColor,
  FontEmphasis,
  FontWeight,
} from '@prisjakt/ui/text/variants';
import Currency from '@prisjakt/ui-currency';

import * as S from './styles';

type Props = {
  className?: string;
  value: number | string | React.ReactNode;
  emphasis?: FontEmphasis;
  fontColor?: FontColor;
  weight?: FontWeight;
};

export const PriceLabel: React.FC<Props> = ({
  className,
  emphasis = FontEmphasis.HIGH,
  fontColor = FontColor.DARK,
  value,
  weight = FontWeight.HEAVIER,
}) => {
  return (
    <S.PriceLabel
      className={className}
      color={fontColor}
      emphasis={emphasis}
      weight={weight}
    >
      {typeof value === 'number' ? <Currency price={value} /> : value}
    </S.PriceLabel>
  );
};
